import { format, getQuarter, isDate, parse } from 'date-fns';

export function getQuarterLabel(date: string | Date): string {
  const parsedDate = isDate(date) ? date : parse(date, 'yyyy-MM-dd', new Date());

  const quarter = getQuarter(parsedDate);
  const shortYear = format(parsedDate, 'yy');

  return `Q${quarter}'${shortYear}`;
}
